export default __webpack_public_path__ + "static/media/term-use-english.8d5a3bcc.png";